import React, { useState, useMemo, createContext, useCallback } from 'react';

// create context
export const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = useCallback(() => {
    setIsSidebarOpen((prev) => !prev);
  }, []);

  const closeSidebar = useCallback(() => {
    setIsSidebarOpen(false);
  }, []);

  const value = useMemo(
    () => ({
      isSidebarOpen,
      toggleSidebar,
      closeSidebar,
    }),
    [closeSidebar, isSidebarOpen, toggleSidebar],
  );


  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
